export enum CharacterOrderEnum {
  LAST_ADDED = 'LAST_ADDED',
  LAST_UPDATED = 'LAST_UPDATED',
  MOST_COINS = 'MOST_COINS',
}
